import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Switch, Route, Redirect } from 'react-router-dom'

import { path, isEmpty } from 'ramda'
import Cookies from 'js-cookie'
import { Icon, Loader, Div, H1 } from '@drifthq/tide-core'

import ProgressMeter from 'components/ProgressMeter'

import PlanSummary from './PlanSummary'
import SalesRepWelcome from './SalesRepWelcome'
import BillingInfoStep from './BillingInfoStep'
import CreateAccountFlowManager from './CreateAccountFlowManager'

import { encodeQueryData } from '../utils/oauthUtils'

import config from 'config'

import { getAccessToken } from 'modules/user/selectors'
import { fetchDeal } from 'modules/billing/actions'
import { getBillingDealLoading, isBillingDealUpgrade, getDeal, isInvoicedDeal, getCustomerInfo } from 'modules/billing/selectors'

import { logError } from 'utils/logger'
import { DealStatus, DealCodeCookie } from 'constants/dealConstants'

import './style.css'
import { api } from 'modules/billing/api'

const dealOrder = Object.freeze([
  '/deal/account',
  '/deal/billing'
])

const mapStateToProps = state => ({
  isDealLoading: getBillingDealLoading(state),
  isUpgrade: isBillingDealUpgrade(state),
  accessToken: getAccessToken(state),
  isInvoiced: isInvoicedDeal(state),
  deal: getDeal(state),
  customerInfo: getCustomerInfo(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchDeal
  }, dispatch),
})

const DealLoader = () => (
  <Div className="deal-layout-loading-view">
    <H1 className="deal-loading-title">Just a moment...</H1>
    <Loader/>
    <Icon className="deal-setup-container-drift-logo" name="drift-logo-full"/>
  </Div>
)

const COMPLETED_CONTRACT_STATUS = 'document.completed'

class DealLayout extends Component {

  componentDidMount() {
    const dealCode = Cookies.get(DealCodeCookie)

    if (isEmpty(this.props.deal) && !!dealCode) {
      this.props.actions.fetchDeal(dealCode)
    }

    if (isEmpty(this.props.deal) && !dealCode) {
      this.props.history.push('/deal-error')
    }
  }

  componentDidUpdate(prevProps) {
    if((this.props.isUpgrade !== prevProps.isUpgrade)
      && this.props.isUpgrade) {
      this.props.history.push('/deal/upgrade')
    }

    if((this.props.deal !== prevProps.deal)
      && this.props.deal.status === DealStatus.EXPIRED){
      this.props.history.push('/deal-expired')
    }

    if((this.props.deal !== prevProps.deal)
      && this.props.deal.status !== DealStatus.EXPIRED) {
      this.checkContractStatus()
    }
  }

  componentDidCatch(error, errorInfo) {
    logError(error, errorInfo)
    this.props.history.push('/deal-error')
  }

  checkContractStatus = () => {
    const { deal } = this.props
    const hasContract = !!deal.customerInfo && !!deal.customerInfo.contract

    if (!hasContract) { return }

    const { contract } = deal.customerInfo
    const onSuccess = contract => {
      if (contract.status !== COMPLETED_CONTRACT_STATUS) {
        this.props.history.push('/deal-pending')
      }
    }

    const onError = (error) => {
      logError(error, {contractId: contract.id})
      this.props.history.push('/deal-error')
    }

    return api.fetchContract(contract.id)
      .then(onSuccess)
      .catch(onError)
  }

  redirectToLogin = ({ dealId }) => {
    const params = {
      redirect: `${config.ONBOARDING_URL}?dealCode=${dealId}`,
    }

    window.location.replace(`${config.START_WEB_URL}?${encodeQueryData(params)}`)
  }

  render() {
    const { match, isDealLoading, isUpgrade, deal, accessToken, isInvoiced, location } = this.props
    const url = path(['url'], match)

    const stepIndex = dealOrder.indexOf(location.pathname) + 1

    if (!isDealLoading && isUpgrade && !accessToken) {
      this.redirectToLogin({ dealId: deal.id })
    }

    return (
      <Div className="deal-setup-container">
        { isDealLoading && <DealLoader/> }
        { !isDealLoading &&
          <Fragment>
            <Div className="deal-setup-container-fields-wrapper">
              <Div className="deal-setup-container-fields">
                <Div className="deal-setup-header">
                  <Icon className="deal-setup-container-drift-logo" name="drift-logo-full"/>
                  {!isInvoiced && <ProgressMeter currentLength={stepIndex} maxLength={dealOrder.length + 1}/> }
                </Div>
                <Switch>
                  <Redirect exact from={`${url}/upgrade`} to={`${url}/billing`}/>
                  <Redirect exact from={url} to={`${url}/account`}/>
                  <Route path={`${url}/account`} component={CreateAccountFlowManager}/>
                  <Route path={`${url}/billing`} component={BillingInfoStep}/>
                </Switch>
              </Div>
            </Div>
            <Div className="deal-setup-container-preview">
              <Switch>
                <Route path={`${url}/account`} component={SalesRepWelcome}/>
                <Route path={`${url}/billing`} component={PlanSummary}/>
              </Switch>
            </Div>
          </Fragment>
        }
      </Div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DealLayout)



// WEBPACK FOOTER //
// ./src/layouts/Deal/index.js